import { Interval, IntervalMapping, MoneyFormatter, PercentageFormatter } from '@summit/models';

import { EboObjectTimePeriod } from '../../base-classes/ebo-object-time-period';
import { PayrollReportingCategory } from '../../payroll/payroll-reporting-category.enum';
import { State } from './state';

export class StatePayrollRate extends EboObjectTimePeriod {
  stateID: string;
  state: State;
  category: PayrollReportingCategory;
  isSalaryOnly: boolean;
  fixed: number;
  fixedInterval: Interval;
  rate: number;
  cap: number;
  threshold: number;
  additionalRate: number;
  comment: string;

  constructor(jsonData?: Partial<StatePayrollRate>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.state) {
        this.state = new State(jsonData.state);
      }
    }
    this.isSalaryOnly ??= false;
    this.fixedInterval ??= Interval.Weekly;
    this.category ??= PayrollReportingCategory.Unknown;
  }

  get summary(): string {
    // console.log(`Displaying Summary: `, this)
    if (this.fixed) {
      return `${MoneyFormatter(this.fixed)} ${IntervalMapping[this.fixedInterval]}`;
    }
    const response = Array<string>();
    if (this.rate) {
      response.push(`${PercentageFormatter(this.rate / 100, 3)}`);
    }
    if (this.cap) {
      response.push(`up to ${MoneyFormatter(this.cap)}`);
    }
    if (this.threshold || this.additionalRate) {
      response.push(
        `and up ${MoneyFormatter(this.threshold)} add ${PercentageFormatter(this.additionalRate / 100, 3)}`
      );
    }
    return response.join(' ');
  }

  toShortString(): string {
    return `${this.state ? this.state.toShortString() : 'Unknown'}`;
  }

  toTimeLineView(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}: ${
      this.state ? this.state.toShortString() : 'Unknown'
    }`;
  }
}
